import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HelpCircle, FileText, BookOpen } from 'lucide-react';
import './Footer.css';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="app-footer" data-testid="app-footer">
      <div className="footer-container">
        <div className="footer-links">
          <Link to="/faq" className="footer-link" data-testid="footer-faq">
            <HelpCircle size={16} />
            {t('nav.faq')}
          </Link>
          <span className="footer-separator">|</span>
          <Link to="/agb" className="footer-link" data-testid="footer-agb">
            <FileText size={16} />
            {t('nav.agb')}
          </Link>
          <span className="footer-separator">|</span>
          <Link to="/impressum" className="footer-link" data-testid="footer-impressum">
            <BookOpen size={16} />
            {t('nav.impressum')}
          </Link>
        </div>
        <div className="footer-copyright">
          VoiceRide &copy; {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
};
